import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Matviews {
  static getStatusMatview (mvname) {
    const axios = getAxiosInstance()
    const promise = axios.get(`matviews?r=` +
      `{"clave":{"mv_name":"${mvname}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default Matviews
